export const pageURLs = Object.freeze({
  login: "/login",
  signup: "/signup",
  wantad: "/home",
  dashboard: "/home",
  home: "/home",
  match: "/match",
  createwantad: "/create-want-listing",
  wantAdDetails: "/want-listing-details",
  notFound: "404-not-found",
  deletedWantAd: "want-listing/deleted-want-listing",
  agentCreatewantadMainScreen: "/want-listing-creation",
  agentCreatewantad: "/create-want-listing-agent",
  agentEditwantad: "/edit-want-listing",
  editWantAdForAgents: "/edit-want-listing-agent",
  inventoryDetails: "/inventory-details",
  memberCreateInventory: "/create-inventory",
  inventoryStrengthen: "/strengthen-inventory",
  selectYourPlan: "/select-your-plan",
  completeYourProfilePremium: "/complete-your-profile-premium",
  completeYourProfileDefault: "/complete-your-profile",
  agentCreateInventory: "/create-inventory",
  consumerInventoryListing: "/my-inventory-listing",
  agentWantAdConfirmation: "/agent-want-ad-confirmation",
  agentInventoryListing: "/my-inventory",
  agentMyClients: "/my-clients",
  agentMyWantAdListings: "/my-want-listings",
  memberEditInventory: "/member-edit-Inventory",
  settings: "/settings",
  addNewCard: "/add-new-card",
  viewClientDetails: "/view-client",
  agentDashboard: "/agent-dashboard",
  allIntroductions: "/all-introductions",
  viewIntroducedInventory: "/view-introduced-property",
  accessCodePage: "/",
  gitchaMemberWelcome: "/want-listing-onboard",
  gitchaPrivacyPolicy: "/privacy-policy",
  gitchaTermsOfService: "/terms-of-service",
  gitchaInvetoryOnBoard: "/inventory-onboard",
  wantAdPubicDetailsPage: "/want-listing",
  messages: "/messages",
  directMessages: "/direct-messages",
  favoriteClients: "/favorite-clients",
  webFavorites: "/my-favorites",
  buyerListingConfirmation: "/confirmation",
  shareWantAdDetails: `/share/:id`,
  agentInfo: "/agent-info",
  SSOCallback: "/sso",
  crossLoginCallback: "/auth/cross-login",
  crossLogoutCallback: "/auth/cross-logout",
  mlsListingDetails: "/mls-listing",
  mlsListingMatches: "/mls-listing/:listingKey/matches",
  adminIframeWidgets: "/admin/iframe-widgets",
});

export const urlLinks = Object.freeze({
  gitchaMLSIntegration: "https://gitcha.com/mls",
  contactUs: "https://gitcha.com/contact"
});
